import React, { Component, Fragment } from "react";
import moment from "moment";
import styled from "styled-components";
import {
  Checkbox,
  DataGridCell,
  Main,
  Supportive,
  AnalyticsTrends,
} from "@conserveit/blocks";
import { todayYesterday } from "../../../utils/time";
import getUniqueId from "../../../utils/getUniqueId";
import RowTip from "../../ToolTip";
import { ToolTip, Tip, TipRow, TipTitle } from "../../ToolTip/ToolTip.styles";
import IssuePreview from "../../IssuePreview";
import RowSnooze from "./RowSnooze";
import RowAction from "./RowAction";
import { clickedTrendGraphEvent } from "../../../utils/eventTracking";
import { EquipListRow, Icon } from "./Equip.styles";

const EquipCell = styled(DataGridCell)`
  overflow: visible;
`;

function formatPrettyHours(hours) {
  // If full day, return early with known values
  // NOTE: moment will treat 24 hours as { hours: 0, days: 1 }
  if (Number(hours) === 24) return { hours: 24, minutes: 0 };
  // Otherwise break out into hours and minutes
  const m = moment.duration({ hours });
  return {
    hours: m.hours(),
    minutes: m.minutes(),
  };
}

function stripProjectPrefix(actionId = "-") {
  return actionId.split("-")[1];
}

const triggerReportViewedEvent = (asset, ruleName, isAssociated) => () => {
  clickedTrendGraphEvent(asset, ruleName, isAssociated);
};

class EquipRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }

  shouldComponentUpdate(prevProps, prevState) {
    return (
      this.props.isSelected !== prevProps.isSelected ||
      prevState.isActive !== this.state.isActive ||
      prevProps.asset !== this.props.asset
    );
  }

  toggleRowActive = (isActive) => {
    this.setState({
      isActive,
    });
  };

  render() {
    const { asset, onSelect, isSelected, isAssociated, ruleName, hideEdits } = this.props;
    const {
      duration,
      targetName: equipName,
      averageDur,
      equipRuleId,
      site,
      description,
      times,
      reportURL,
      issueKey,
      ruleType,
      isSnoozed,
      snoozeEnd,
      occurredOn,
    } = asset;

    const total = formatPrettyHours(duration);
    const average = formatPrettyHours(averageDur);

    return (
      <EquipListRow
        isActive={this.state.isActive}
        isSnoozed={isSnoozed}
        data-cy="EquipRow"
        cursor="pointer"
      >
        <EquipCell>
          {!isAssociated ? (
            <div hidden={hideEdits}>
              <Checkbox checked={isSelected} onChange={onSelect} small />
            </div>
          ) : (
            ""
          )}
        </EquipCell>

        <EquipCell>
          <Main>{todayYesterday(moment(occurredOn))}</Main>
        </EquipCell>

        <EquipCell maxWidth="200px">
          <Main title={equipName}>{equipName}</Main>
        </EquipCell>

        <EquipCell>
          <RowTip>
            {({ isOpen, open, close }) => (
              <div
                style={{ position: "relative" }}
                onMouseEnter={open}
                onMouseLeave={close}
              >
                <Main>
                  {times.length} Hit{times.length > 1 ? "s" : ""}
                </Main>
                <Supportive>Avg. {averageDur} hrs</Supportive>
                <ToolTip isOpen={isOpen}>
                  <Tip>
                    <TipTitle>
                      <div>Hits Duration (24hr period)</div>
                    </TipTitle>
                    <TipRow>
                      <div>
                        Total:{" "}
                        <strong>
                          {total.hours}hr {total.minutes}mins
                        </strong>
                      </div>
                      <div>
                        Average:{" "}
                        <strong>
                          {average.hours}hr {average.minutes}mins
                        </strong>
                      </div>
                    </TipRow>
                    <TipRow>
                      <div>
                        {times.map((time) => (
                          <div key={getUniqueId()}>{time}</div>
                        ))}
                      </div>
                    </TipRow>
                  </Tip>
                </ToolTip>
              </div>
            )}
          </RowTip>
        </EquipCell>
        <DataGridCell>
          <Main title={description}>{description}</Main>
        </DataGridCell>

        <EquipCell>
          <Main>
            <span>{ruleType}</span>
          </Main>
        </EquipCell>

        <EquipCell minWidth="120px">
          <Fragment>
            {issueKey ? (
              <IssuePreview id={issueKey}>
                <Fragment>#{stripProjectPrefix(issueKey)}</Fragment>
              </IssuePreview>
            ) : (
              <span />
            )}
          </Fragment>
        </EquipCell>

        <EquipCell minWidth="140px">
          <div className="Row-actions-snoozeIcon">
            <RowSnooze
              isSnoozed={isSnoozed}
              snoozeEnd={snoozeEnd}
              onMenuToggle={this.toggleRowActive}
              equipRuleId={equipRuleId}
              isHidden={hideEdits}
            />
          </div>

          <div className="Row-actions-reportIcon">
            <Icon>
              <a
                href={reportURL}
                onClick={triggerReportViewedEvent(
                  asset,
                  ruleName,
                  isAssociated
                )}
                target="_blank"
                rel="noopener"
              >
                <AnalyticsTrends />
              </a>
            </Icon>
          </div>
          <div className="Row-actions-actionIcon">
            <RowAction
              siteId={site.id}
              ruleName={ruleName}
              equipRuleId={equipRuleId}
              equipName={equipName}
              onMenuToggle={this.toggleRowActive}
              isAssociated={isAssociated}
              isHidden={hideEdits}
            />
          </div>
        </EquipCell>
      </EquipListRow>
    );
  }
}

EquipRow.propTypes = {};

export default EquipRow;
